/* eslint-disable import/default */

import PromisePolyfill from 'promise-polyfill';

// To add to window
if (!window.Promise) {
  window.Promise = PromisePolyfill;
}

import React from 'react';
import {render} from 'react-dom';
import {Router, browserHistory} from 'react-router';

import routes from './routes';

render(
  <Router routes={routes} history={browserHistory} />,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js